import React from "react";
import { Banner as DcBanner, Favorite } from "@/components";

/**横幅 */
export const Banner = (props) => {
  return (
    <section className="page-restaurant--banner">
      <DcBanner {...props} />
      <Favorite {...props} />
      {props.post}
    </section>
  );
};
